export default __webpack_public_path__ + "static/media/AppStoreDownload.3db7f939.png";